"use client";

import { ReactNode, createContext, useContext } from "react";

const StepPayloadPreviewContext = createContext<unknown>(undefined);

export const StepPayloadPreviewProvider = ({
	children,
	value,
}: {
	children: ReactNode;
	value: unknown;
}) => (
	<StepPayloadPreviewContext.Provider value={value}>
		{children}
	</StepPayloadPreviewContext.Provider>
);

export const useStepPayloadPreviewContext = () =>
	useContext(StepPayloadPreviewContext);
